/* eslint-disable import/prefer-default-export */

import type { Organization } from '@openclassrooms/sdk-web';
import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useGet: useOrganization } = getCRUDHooks<Organization>({
  entityName: 'userOrganization',
  get: ({ userId }: { userId?: number }) => {
    if (userId) {
      return clientApi.getOCClient().helpers.user.users.getOrganization(userId);
    }

    return clientApi.getOCClient().helpers.user.me.getOrganization();
  },
});

export { useOrganization };
